// the ts way does not work here
export var md = require("markdown-it")({ html: true });
// @ts-ignore
var markdownItAttrs = require("markdown-it-attrs");

md.use(markdownItAttrs);
